import { FC, ReactNode,useState } from "react";
import { Outlet } from "react-router-dom";

import Sidebar from "./Sidebar";
import Header from "./Header";
import { LayoutWrapper, ContentWrapper } from "./styles";
import { Box } from "@mui/material";
import { FooterLeft, FooterRight, FooterWrapper } from "utility/styles";
import { FOOTER_TEXTS } from "utility/constants";

interface SidebarLayoutProps {
  children?: ReactNode;
}

const SidebarLayout: FC<SidebarLayoutProps> = () => {
  const copyRightYear = new Date().getFullYear();
  const [collapsed, setCollapsed] = useState<boolean>(false);
  const toggleSidebarSize = (): void => {
    setCollapsed((prev) => !prev);
  };

  return (
    <div>
      <LayoutWrapper>
        <Header collapsed={collapsed}/>
        <Sidebar collapsed={collapsed} toggleSidebarSize={toggleSidebarSize}/>
        <ContentWrapper collapsed={collapsed}>
          <Box display="block" flexGrow={1}>
            <Outlet />
          </Box>
          <FooterWrapper>
            <FooterLeft>{FOOTER_TEXTS.footerLeft}</FooterLeft>
            <FooterRight>
              {FOOTER_TEXTS.footerRight.replace(
                "{copyRightYear}",
                String(copyRightYear)
              )}
            </FooterRight>
          </FooterWrapper>
        </ContentWrapper>
      </LayoutWrapper>
    </div>
  );
};

export default SidebarLayout;
